// @flow

import type { Action } from './store.type';
import type { FilterDataType } from 'src/models/filter-data';

export const GET_FILTER_DATA_REQUEST = 'GET_FILTER_DATA_REQUEST';
type GET_FILTER_DATA_REQUEST_TYPE = 'GET_FILTER_DATA_REQUEST';

export const GET_FILTER_DATA_SUCCESS = 'GET_FILTER_DATA_SUCCESS';
type GET_FILTER_DATA_SUCCESS_TYPE = 'GET_FILTER_DATA_SUCCESS';

export const GET_FILTER_DATA_FAILURE = 'GET_FILTER_DATA_FAILURE';
type GET_FILTER_DATA_FAILURE_TYPE = 'GET_FILTER_DATA_FAILURE';

type FilterDataSuccess = {
  data: FilterDataType
};

type FilterDataFailure = {
  error: any
};

type GetFilterDataRequestAction = Action<GET_FILTER_DATA_REQUEST_TYPE, null>;

type GetFilterDataSuccessAction = Action<GET_FILTER_DATA_SUCCESS_TYPE, FilterDataSuccess>;

type GetFilterDataFailureAction = Action<GET_FILTER_DATA_FAILURE_TYPE, FilterDataFailure>;

export const GET_PRODUCT_ATTRIBUTE_REQUEST = 'GET_PRODUCT_ATTRIBUTE_REQUEST';
type GET_PRODUCT_ATTRIBUTE_REQUEST_TYPE = 'GET_PRODUCT_ATTRIBUTE_REQUEST';

export const GET_PRODUCT_ATTRIBUTE_SUCCESS = 'GET_PRODUCT_ATTRIBUTE_SUCCESS';
type GET_PRODUCT_ATTRIBUTE_SUCCESS_TYPE = 'GET_PRODUCT_ATTRIBUTE_SUCCESS';

export const GET_PRODUCT_ATTRIBUTE_FAILURE = 'GET_PRODUCT_ATTRIBUTE_FAILURE';
type GET_PRODUCT_ATTRIBUTE_FAILURE_TYPE = 'GET_PRODUCT_ATTRIBUTE_FAILURE';

type GetProductAttributeRequestAction = Action<GET_PRODUCT_ATTRIBUTE_REQUEST_TYPE, null>;

type GetProductAttributeSuccessAction = Action<
  GET_PRODUCT_ATTRIBUTE_SUCCESS_TYPE,
  FilterDataSuccess
>;

type GetProductAttributeFailureAction = Action<
  GET_PRODUCT_ATTRIBUTE_FAILURE_TYPE,
  FilterDataFailure
>;

// Get filter data by type
export const GET_FILTER_DATA_BY_TYPE_REQUEST = 'GET_FILTER_DATA_BY_TYPE_REQUEST';
type GET_FILTER_DATA_BY_TYPE_REQUEST_TYPE = 'GET_FILTER_DATA_BY_TYPE_REQUEST';

export const GET_FILTER_DATA_BY_TYPE_SUCCESS = 'GET_FILTER_DATA_BY_TYPE_SUCCESS';
type GET_FILTER_DATA_BY_TYPE_SUCCESS_TYPE = 'GET_FILTER_DATA_BY_TYPE_SUCCESS';

export const GET_FILTER_DATA_BY_TYPE_FAILURE = 'GET_FILTER_DATA_BY_TYPE_FAILURE';
type GET_FILTER_DATA_BY_TYPE_FAILURE_TYPE = 'GET_FILTER_DATA_BY_TYPE_FAILURE';

type GetFilterDataByTypeRequestAction = Action<GET_FILTER_DATA_BY_TYPE_REQUEST_TYPE, null>;

type GetFilterDataByTypeSuccessAction = Action<
  GET_FILTER_DATA_BY_TYPE_SUCCESS_TYPE,
  FilterDataSuccess
>;

type GetFilterDataByTypeFailureAction = Action<
  GET_FILTER_DATA_BY_TYPE_FAILURE_TYPE,
  FilterDataFailure
>;

//
export type FilterDataAction =
  | GetFilterDataRequestAction
  | GetFilterDataSuccessAction
  | GetFilterDataFailureAction
  | GetProductAttributeRequestAction
  | GetProductAttributeSuccessAction
  | GetProductAttributeFailureAction
  | GetFilterDataByTypeRequestAction
  | GetFilterDataByTypeSuccessAction
  | GetFilterDataByTypeFailureAction;

export type FilterDataState = {
  loading: boolean,
  success: boolean,
  loadingDataByType: boolean,
  successDataByType: boolean,
  error: any,
  filterData: FilterDataType | {},
  productAttributes: FilterDataType | {},
  filterDataByType: Array<Object>,
  filterDataType: string,
  filterDataByTypeFirstPage: Array<Object>
};
